/**
 * RegistrationStatusService
 * Service for managing registration statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for registration status CRUD operations
 */
export class RegistrationStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RegistrationStatusService.DEFAULT_SERVICE_PATH,
            basePath: RegistrationStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RegistrationStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
RegistrationStatusService.BASE_PATH = 'api/registration-statuses';
//# sourceMappingURL=RegistrationStatusService.js.map